import { addNewBlock } from '../utils/add-new-block';
import { convert } from '../utils/convert';
import { Buzzer, GuardZone, HeatingCircuit, Notification, OutputAction, Pump, RelayControl, Scenario, ThreewayTap, } from 'z3k-config';
import { FixedBlockType } from '../types/block-type';
import { CommandArgument, commandReactionTranslate, SetGuardArgument, setGuardReactionTranslate, ThreewayTapArgument, threewayTapReactionTranslate, } from '../utils/translates';
var ScenarioType = Scenario.Type;
function addNotificationDoBlock(color_of_reaction_blocks, config) {
    const options = convert(Notification.get.all(config));
    if (options.length === 0) {
        return null;
    }
    const block = {
        message0: 'Послать оповещение %1',
        args0: [
            {
                type: 'field_dropdown',
                name: 'id',
                options,
            },
        ],
        previousStatement: null,
        nextStatement: null,
        colour: color_of_reaction_blocks,
        tooltip: '',
        helpUrl: '',
    };
    addNewBlock(FixedBlockType.do_notification, block);
    return FixedBlockType.do_notification;
}
function addOutputActionDoBlock(color_of_reaction_blocks, config) {
    const options = convert(OutputAction.get.all(config));
    if (options.length === 0) {
        return null;
    }
    const block = {
        message0: 'Выполнить действие %1',
        args0: [
            {
                type: 'field_dropdown',
                name: 'id',
                options,
            },
        ],
        previousStatement: null,
        nextStatement: null,
        colour: color_of_reaction_blocks,
        tooltip: '',
        helpUrl: '',
    };
    addNewBlock(FixedBlockType.do_output_action, block);
    return FixedBlockType.do_output_action;
}
function addPumpDoBlock(color_of_reaction_blocks, config) {
    const options = convert(Pump.get.all(config));
    if (options.length === 0) {
        return null;
    }
    const block = {
        message0: 'Насос %1 %2',
        args0: [
            {
                type: 'field_dropdown',
                name: 'id',
                options,
            },
            {
                type: 'field_dropdown',
                name: 'argument',
                options: [
                    [
                        commandReactionTranslate[CommandArgument.ON],
                        CommandArgument.ON.toString(),
                    ],
                    [
                        commandReactionTranslate[CommandArgument.OFF],
                        CommandArgument.OFF.toString(),
                    ],
                ],
            },
        ],
        previousStatement: null,
        nextStatement: null,
        colour: color_of_reaction_blocks,
        tooltip: '',
        helpUrl: '',
    };
    addNewBlock(FixedBlockType.do_pump, block);
    return FixedBlockType.do_pump;
}
function addRelayDoBlock(color_of_reaction_blocks, config) {
    const options = convert(RelayControl.get.all(config));
    if (options.length === 0) {
        return null;
    }
    const block = {
        message0: 'Реле %1 %2',
        args0: [
            {
                type: 'field_dropdown',
                name: 'id',
                options,
            },
            {
                type: 'field_dropdown',
                name: 'argument',
                options: [
                    [
                        commandReactionTranslate[CommandArgument.ON],
                        CommandArgument.ON.toString(),
                    ],
                    [
                        commandReactionTranslate[CommandArgument.OFF],
                        CommandArgument.OFF.toString(),
                    ],
                ],
            },
        ],
        previousStatement: null,
        nextStatement: null,
        colour: color_of_reaction_blocks,
        tooltip: '',
        helpUrl: '',
    };
    addNewBlock(FixedBlockType.do_relay, block);
    return FixedBlockType.do_relay;
}
function addSetGuardDoBlock(color_of_reaction_blocks, config) {
    const options = convert(GuardZone.get.all(config));
    if (options.length === 0) {
        return null;
    }
    const block = {
        message0: '%1 охранную зону %2',
        args0: [
            {
                type: 'field_dropdown',
                name: 'argument',
                options: [
                    [
                        setGuardReactionTranslate[SetGuardArgument.GUARD_ON],
                        SetGuardArgument.GUARD_ON.toString(),
                    ],
                    [
                        setGuardReactionTranslate[SetGuardArgument.GUARD_OFF],
                        SetGuardArgument.GUARD_OFF.toString(),
                    ],
                    [
                        setGuardReactionTranslate[SetGuardArgument.INVERT],
                        SetGuardArgument.INVERT.toString(),
                    ],
                ],
            },
            {
                type: 'field_dropdown',
                name: 'id',
                options,
            },
        ],
        previousStatement: null,
        nextStatement: null,
        colour: color_of_reaction_blocks,
        tooltip: '',
        helpUrl: '',
    };
    addNewBlock(FixedBlockType.set_guard, block);
    return FixedBlockType.set_guard;
}
function addSirenDoBlock(color_of_reaction_blocks, config) {
    const options = convert(Buzzer.get.all(config));
    if (options.length === 0) {
        return null;
    }
    const block = {
        message0: 'Сирену %1 %2',
        args0: [
            {
                type: 'field_dropdown',
                name: 'id',
                options,
            },
            {
                type: 'field_dropdown',
                name: 'argument',
                options: [
                    [
                        commandReactionTranslate[CommandArgument.ON],
                        CommandArgument.ON.toString(),
                    ],
                    [
                        commandReactionTranslate[CommandArgument.OFF],
                        CommandArgument.OFF.toString(),
                    ],
                ],
            },
        ],
        previousStatement: null,
        nextStatement: null,
        colour: color_of_reaction_blocks,
        tooltip: '',
        helpUrl: '',
    };
    addNewBlock(FixedBlockType.do_buzzer, block);
    return FixedBlockType.do_buzzer;
}
function addTapDoBlock(color_of_reaction_blocks, config) {
    const options = convert(ThreewayTap.get.all(config));
    if (options.length === 0) {
        return null;
    }
    const block = {
        message0: 'Кран %1 %2',
        args0: [
            {
                type: 'field_dropdown',
                name: 'id',
                options,
            },
            {
                type: 'field_dropdown',
                name: 'argument',
                options: [
                    [
                        threewayTapReactionTranslate[ThreewayTapArgument.OPEN],
                        ThreewayTapArgument.OPEN.toString(),
                    ],
                    [
                        threewayTapReactionTranslate[ThreewayTapArgument.CLOSE],
                        ThreewayTapArgument.CLOSE.toString(),
                    ],
                ],
            },
        ],
        previousStatement: null,
        nextStatement: null,
        colour: color_of_reaction_blocks,
        tooltip: '',
        helpUrl: '',
    };
    addNewBlock(FixedBlockType.do_tap, block);
    return FixedBlockType.do_tap;
}
function addTemperatureDoBlock(color_of_reaction_blocks, config) {
    const options = convert(HeatingCircuit.get.all(config));
    if (options.length === 0) {
        return null;
    }
    const block = {
        message0: 'Установить целевую температуру %1 %2 для контура %3',
        args0: [
            {
                type: 'field_number',
                name: 'target_temp',
                value: 0,
                min: -50,
                max: 100,
            },
            {
                type: 'input_dummy',
            },
            {
                type: 'field_dropdown',
                name: 'circuit',
                options,
            },
        ],
        previousStatement: null,
        nextStatement: null,
        tooltip: '',
        helpUrl: '',
        colour: color_of_reaction_blocks,
    };
    addNewBlock(FixedBlockType.do_temperature_in_circuit, block);
    return FixedBlockType.do_temperature_in_circuit;
}
function addScenarioDoBlock(color_of_reaction_blocks, config, current_scenario) {
    //Берём все сценарии, кроме себя
    const options = convert(Scenario.get.where(config, (scenario) => scenario.id !== current_scenario.id &&
        Scenario.getType(scenario) === ScenarioType.LINEAR));
    if (options.length === 0) {
        return null;
    }
    const block = {
        message0: 'Выполнить сценарий %1',
        args0: [
            {
                type: 'field_dropdown',
                name: 'scenario',
                options,
            },
        ],
        previousStatement: null,
        nextStatement: null,
        tooltip: '',
        helpUrl: '',
        colour: color_of_reaction_blocks,
    };
    const block_type = FixedBlockType.do_scenario;
    addNewBlock(block_type, block);
    return block_type;
}
const stop_scenario_color = '#444';
function addReturnBlock(color_of_reaction_blocks) {
    const block = {
        message0: 'Завершить сценарий',
        args0: [],
        previousStatement: null,
        nextStatement: null,
        colour: stop_scenario_color,
        tooltip: '',
        helpUrl: '',
    };
    addNewBlock(FixedBlockType.do_return, block);
    return FixedBlockType.do_return;
}
function addBreakBlock(color_of_reaction_blocks) {
    const block = {
        message0: 'Выход из блока',
        args0: [],
        previousStatement: null,
        nextStatement: null,
        colour: stop_scenario_color,
        tooltip: '',
        helpUrl: '',
    };
    addNewBlock(FixedBlockType.do_return, block);
    return FixedBlockType.do_return;
}
function addContinueBlock(color_of_reaction_blocks) {
    const block = {
        message0: 'Продолжить блок',
        args0: [],
        previousStatement: null,
        nextStatement: null,
        colour: stop_scenario_color,
        tooltip: '',
        helpUrl: '',
    };
    addNewBlock(FixedBlockType.do_return, block);
    return FixedBlockType.do_return;
}
/**
 * @function
 * Создаю прототипы блоков, чтобы добавить в toolbox
 * @param color_of_logic_blocks - цвет блоков
 * @param config - Z3KConfig устройства
 * @param current_scenario - текущий сценарий
 * @return BlockType[] - названия типов блоков
 */
export function generateDoBlocks(color_of_logic_blocks, config, current_scenario) {
    return [
        addScenarioDoBlock,
        addNotificationDoBlock,
        addOutputActionDoBlock,
        addPumpDoBlock,
        addRelayDoBlock,
        addSetGuardDoBlock,
        addSirenDoBlock,
        addTapDoBlock,
        addTemperatureDoBlock,
        addReturnBlock,
    ]
        .map((func) => func(color_of_logic_blocks, config, current_scenario))
        .filter((item) => item != null);
}
